import React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 58 69"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="98.993%" id="c">
        <stop stopColor="#4AB6F5" offset="0%" />
        <stop stopColor="#227BF9" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="b">
        <stop stopColor="#7DCFFF" offset="0%" />
        <stop stopColor="#60A2FE" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="15.471%"
        y1="14.721%"
        x2="90.626%"
        y2="87.999%"
        id="d"
      >
        <stop stopColor="#E2F2FF" offset="0%" />
        <stop stopColor="#E2F2FF" offset="100%" />
      </linearGradient>
      <filter
        x="-44%"
        y="-37%"
        width="187.9%"
        height="173.9%"
        filterUnits="objectBoundingBox"
        id="a"
      >
        <feOffset dy={3} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#a)" fill="none" fillRule="evenodd">
      <path
        d="M29 5c6.35 0 12.1 2.59 16.261 6.774A23.132 23.132 0 0 1 52 28.136c0 5.526-3.422 12.305-7.652 18.275C38.784 54.26 31.73 61 29 61c-2.73 0-9.784-6.74-15.348-14.59C9.422 40.442 6 33.663 6 28.137c0-6.39 2.575-12.174 6.739-16.362C16.9 7.59 22.649 5 29 5Z"
        stroke="url(#b)"
        strokeWidth={2}
        fill="url(#c)"
      />
      <path
        d="M21.484 2.784 19.034.335a1.127 1.127 0 0 0-1.602 0 1.144 1.144 0 0 0 0 1.615l1.587 1.6-1.174 1.231a1.029 1.029 0 0 0 0 1.427c.187.2.438.299.687.299h.01l1.329-.003V16.95a.708.708 0 0 1-.696.712h-.013a.695.695 0 0 1-.68-.697v-6.508a3.01 3.01 0 0 0-3.002-3.02.696.696 0 0 1-.693-.696V1.86A1.853 1.853 0 0 0 12.939.002H3.235c-1.02 0-1.848.832-1.848 1.858v17.912a.215.215 0 0 1-.212.216c-.31 0-.596.122-.808.322-.214.196-.35.475-.366.787a1.157 1.157 0 0 0 1.155 1.21h13.847a1.17 1.17 0 0 0 1.172-1.147 1.156 1.156 0 0 0-1.154-1.174.234.234 0 0 1-.234-.236v-9.29a.694.694 0 1 1 1.388.002v6.505a3.012 3.012 0 0 0 3.003 3.02 3.014 3.014 0 0 0 3.004-3.02V4.452c0-.655-.269-1.246-.698-1.668Zm-17.787.525c0-.709.663-1.281 1.479-1.281h6.285c.815 0 1.478.572 1.478 1.28v3.523c0 .707-.663 1.28-1.478 1.28H5.176c-.816 0-1.479-.573-1.479-1.28V3.31ZM20.333 6.08l-1.279.004h-.57l.782-.992.817-1.036c.164.273.25.592.25.93V6.08Z"
        transform="translate(19.018 16.668)"
        fill="url(#d)"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComponent
